export enum MakePaymentModalResultEnum {
    Success,
    FailureAllowRetry,
    FailureNoRetry
}
